import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import axiosInstance from "../../configs/axios/axios ";
import {
  GET_TARGET_INFO,
  CHECK_PASSWORD_FILE,
} from "../../configs/axios/constantsAPI";

export const getTargetInfoAction = createAsyncThunk(
  "download/getTargetInfo",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    try {
      const { data } = await axiosInstance.post(
        GET_TARGET_INFO,
        JSON.stringify(sendData)
      );

      if (!!data.content?.link) {
        const link = document.createElement("a");
        link.href = data.content?.link;
        link.setAttribute("target", "_self");
        document.body.appendChild(link);
        link.click();
        link.remove();

        // setTimeout(() => {
        //   window.location.replace("/download");
        // }, 500);
      }

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const checkPasswordFileAction = createAsyncThunk(
  "download/checkPasswordFile",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    try {
      const { data } = await axiosInstance.post(
        CHECK_PASSWORD_FILE,
        JSON.stringify(sendData)
      );

      if (!!data.content?.link) {
        const link = document.createElement("a");
        link.href = data.content?.link;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
        // window.location.reload();
      }

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface DownloadState {
  downloadData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    fileName: string;
    idChacked: boolean;
    isPassword: boolean;
    hash: string;
    id: number | null;
    redirect: boolean;
  };
}

const initialState: DownloadState = {
  downloadData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    fileName: "",
    idChacked: false,
    isPassword: false,
    hash: "",
    id: null,
    redirect: false,
  },
};

export const downloadSlice = createSlice({
  name: "download",
  initialState,
  reducers: {
    resetDownloadStatusAction: (state) => {
      state.downloadData = {
        ...state.downloadData,
        actionStatus: "",
        alert: {
          error: false,
          message: "",
        },
      };
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getTargetInfoAction.pending, (state) => {
      state.downloadData.actionStatus = "loading";
      state.downloadData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(getTargetInfoAction.fulfilled, (state, { payload }) => {
      state.downloadData.actionStatus = "success";
      state.downloadData.alert = {
        error: payload?.content?.error,
        message: payload?.content?.message
          ? payload?.content?.message
          : "Great, we didn't encounter any errors!",
      };
      state.downloadData.idChacked =
        payload?.content?.message === "okid" ? true : false;
      state.downloadData.isPassword = payload?.content?.password;
      state.downloadData.fileName = payload?.content?.name;
      state.downloadData.hash = payload?.content?.hash;
      state.downloadData.id = payload?.content?.id;
      state.downloadData.redirect = !!payload?.content?.link ? true : false;
    });
    addCase(getTargetInfoAction.rejected, (state, { payload }: any) => {
      state.downloadData.actionStatus = "rejected";
      state.downloadData.alert = {
        error: payload?.content?.error,
        message: payload?.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });

    addCase(checkPasswordFileAction.pending, (state) => {
      state.downloadData.actionStatus = "loading";
      state.downloadData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(checkPasswordFileAction.fulfilled, (state, { payload }) => {
      state.downloadData.actionStatus = "success";
      state.downloadData.alert = {
        error: payload?.content?.error,
        message: payload?.content?.message
          ? payload?.content?.message
          : "Great, we didn't encounter any errors!",
      };
    });
    addCase(checkPasswordFileAction.rejected, (state, { payload }: any) => {
      state.downloadData.actionStatus = "rejected";
      state.downloadData.alert = {
        error: payload?.content?.error,
        message: payload?.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const { resetDownloadStatusAction } = downloadSlice.actions;

export const download = (state: RootState) => state.downloadState;

export default downloadSlice.reducer;
